import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import { useIdleTimer } from 'react-idle-timer';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { startResetAllBusinessSlices } from '../../store/agreement';
import { URLRoutes } from '../../config';
import { useTranslation } from 'react-i18next';
const SECONDS = 60*5;

export const IdleReset = ({ handleKeepAlive, active }) => {
    const [remaining, setRemaining] = React.useState(SECONDS);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { i18n: { t } } = useTranslation();

    const onIdle = async () => {
        setRemaining(0);
        navigate(URLRoutes.clientHome());
        await dispatch( startResetAllBusinessSlices() );
    };

    const onActive = () => {
        setRemaining(SECONDS);
    };

    const { getRemainingTime, activate } = useIdleTimer({
        onIdle,
        onActive,
        timeout: 1000 * SECONDS,
        throttle: 500,
        stopOnIdle: true,
        syncTimers: 200
    });

    React.useEffect(() => {
        const interval = setInterval(() => {
            const time = Math.ceil(getRemainingTime() / 1000);
            setRemaining(time);
        }, 500);

        return () => clearInterval(interval);
    }, [getRemainingTime]);

  return (
    <Dialog
        fullWidth
        maxWidth={'sm'}
        open
        onClose={handleKeepAlive}
        onClick={handleKeepAlive}
        PaperProps={{
            sx: {
                background: 'linear-gradient(170deg, #6d0494 0%, #0b2752 52%, #110861 100%)',
                borderRadius: '24px',
                color: '#FFF',
                p: 2,
            }
        }}
    >
        <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold' }}>
            { t('App.Components.are_you_there') }
        </DialogTitle>
        <DialogContent>
            <DialogContentText sx={{ textAlign: 'center', color: 'rgba(255, 255, 255, 0.7)' }}>
                { t('App.Components.session_will_expire_in') }
            </DialogContentText>
            <DialogContentText sx={{ textAlign: 'center', color: 'rgba(255, 255, 255, 0.7)' }}>
                { String(Math.floor(remaining/60)).padStart(1, '0') } : { String(remaining - Math.floor(remaining/60) * 60).padStart(2, '0') }
            </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ flexDirection: 'column', pb: 4 }}>
            <Button
                variant="contained"
                onClick={handleKeepAlive}
                sx={{
                    width: '90%',
                    background: 'linear-gradient(180deg, #ffffff 0%, #11aac5 100%)',
                    color: '#ffffff',
                    textShadow: '0px 0px 5px #000',
                    borderRadius: '20px',
                    fontWeight: 'bold',
                }}
            >
                { t('App.Components.btn_im_here') }
            </Button>
        </DialogActions>
    </Dialog>
  )
}
